import { render, staticRenderFns } from "./AnswersBlock.vue?vue&type=template&id=43eb13ee"
import script from "./AnswersBlock.vue?vue&type=script&lang=js"
export * from "./AnswersBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports